export default __webpack_public_path__ + "static/media/85.74aea798.png";